<template>
  <div>
    <div v-if="!Array.isArray(output)" class="code-output focus-wave">
      <v-color-icon :size="16" name="terminal"></v-color-icon>
      <pre class="output">{{ output }}</pre>
    </div>
    <div v-else>
      <template v-for="out in output">
        <div v-if="out.type.indexOf('text') === 0" class="code-output focus-wave">
          <v-color-icon :size="16" name="terminal"></v-color-icon>
          <pre class="output">{{ out.value }}</pre>
        </div>
        <figure v-if="out.type.indexOf('image') === 0">
          <p>{{ out.value.filename }}</p>
          <img :src="out.value.data" alt="">
        </figure>
      </template>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['output'],
  data () {
    return {
      timer: null,
      scrollToBottom: _.throttle(this.scroll, 100)
    }
  },
  watch: {
    output () {
      this.scrollToBottom()
    }
  },
  methods: {
    scroll () {
      this.$el.scrollTop = this.$el.scrollHeight
    }
  }
}
</script>

<style lang="stylus" scoped>
.code-output {
  display block
  padding-left 30px
  position relative
  overflow hidden
  font-size 14px

  .output {
    overflow auto
    max-height 200px
    padding 0 5px
    color #393566
    font-family Monaco, Menlo, "Ubuntu Mono", Consolas, source-code-pro, monospace
  }

  &:before {
    content ''
    position absolute
    left 0
    top 1px
    width 30px
    height 20px
    background white
    border-radius 10px
  }

  .icon {
    position absolute
    left 8px
    top 3px
    fill #8CA1AB
  }
}
</style>
